import { initVersionedSchema } from '@principle-theorem/editor';
import {
  IContact,
  IPatient,
  IPractice,
  IReferral,
  IReferralPatientLetter,
  MentionResourceType,
  ReferralActor,
  ReferralStatus,
  ReferralType,
  ReferralUrgency,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseFirestoreMock,
  MockISODate,
  MockTimestamp,
  Properties,
  uid,
} from '@principle-theorem/shared';
import { MockDocRef, MockNamedDocument } from '@principle-theorem/testing';

export class ReferralMock
  extends BaseFirestoreMock<Properties<IReferral>>
  implements Properties<IReferral>
{
  uid = `referral-${uid()}`;
  status = ReferralStatus.Draft;
  statusHistory = [];
  type = ReferralType.Outgoing;
  referrer = {
    name: 'Dr. Jane Smith',
    ref: MockDocRef<IContact>(),
    type: MentionResourceType.Contact as const,
  };
  recipient = {
    name: 'Dr. John Doe',
    ref: MockDocRef<IContact>(),
    type: MentionResourceType.Contact as const,
  };
  patient = MockNamedDocument<IPatient>('Test Patient');
  participants = [];
  unreadBy = [];
  followers = [];
  practice = MockNamedDocument<IPractice>('Test Practice');
  stafferDetails = {
    name: 'Test Practice',
    email: 'info@testpractice.au',
    phone: '02 0000 0000',
  };
  patientDetails = {
    name: 'Test Patient',
    dateOfBirth: MockISODate(),
    includePhone: false,
    includeEmail: false,
    includeAddress: false,
  };
  urgency = ReferralUrgency.Routine;
  emailInvitationSent = false;
  externalUserEmail = '';
  lastActivityBy: ReferralActor = {
    name: 'Last Activity By',
    ref: MockDocRef<IContact>(),
    type: MentionResourceType.Contact as const,
  };
  lastNotifiedAt = MockTimestamp();
  patientLetter: IReferralPatientLetter = {
    content: initVersionedSchema(),
    includeClinicalNotes: false,
    selectedAttachmentRefs: [],
    selectedClinicalNoteRefs: [],
    headerTemplate: initVersionedSchema(),
    footerTemplate: initVersionedSchema(),
  };
}
